import { Popup } from '@cian/popup-component';
import * as React from 'react';

import { ModalWrapper } from '../../../../common/components/modal/wrapper';
import { CloseBtn } from '../../../../common/components/close_button';
import * as style from './SavedSearchModal.css';

export interface ISavedSearchModalProps {
  isAuthenticated: boolean;
  userEmail: string | null;
  email: string;
  setVisibility(isVisible: boolean): void;
  onClose?(): void;
}

export class SavedSearchModal extends React.Component<ISavedSearchModalProps, {}> {
  private handleModalClose = () => {
    const { onClose, setVisibility } = this.props;
    setVisibility(false);
    if (onClose) {
      onClose();
    }
  };

  private checkUserEmail() {
    const { isAuthenticated, userEmail, email } = this.props;

    return isAuthenticated && userEmail && email.trim().toLowerCase() === userEmail.toLowerCase();
  }

  public render() {
    const { email } = this.props;

    return (
      <ModalWrapper onClose={this.handleModalClose}>
        <Popup containerStyle={style['modal']}>
          <CloseBtn onClick={this.handleModalClose} />
          <h3 className={style['title']}>
            Поиск сохранён <span className={style['emoji']}>😊</span>
          </h3>
          <div className={style['success']}>
            <div className={style['success-text']}>
              {this.checkUserEmail()
                ? 'Мы оповестим вас, когда появятся новые объявления по вашему поиску'
                : 'Активируйте вашу подписку с помощью ссылки из письма, отправленного на адрес'}
            </div>
            <div className={style['success-email']}>{email}</div>
          </div>
        </Popup>
      </ModalWrapper>
    );
  }
}
